import { render, staticRenderFns } from "./FishButton.vue?vue&type=template&id=69f185df&"
import script from "./FishButton.vue?vue&type=script&lang=ts&"
export * from "./FishButton.vue?vue&type=script&lang=ts&"
import style0 from "./FishButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports